module.exports = __webpack_public_path__ + "8ce2eb78/img/comments-icon.fdec7fdb.svg";